const PAGES_LIMIT_WARNING = 2;

const getUpgradeBannerVisibilityItems = ({ isFreePackageType, pagesFeatureLimit, pagesAmount }) => {
  if (isFreePackageType) {
    return {
      withProgressBar: true,
      withUpgrade: true,
    };
  }

  if (!pagesFeatureLimit.upgradeAvailable) {
    return {
      withProgressBar: false,
      withUpgrade: false,
    };
  }

  return {
    withProgressBar: pagesFeatureLimit.amount - pagesAmount <= PAGES_LIMIT_WARNING,
    withUpgrade: true,
  };
};

export default getUpgradeBannerVisibilityItems;
